// Shared project registry used by the landing page block and the /projects overview.
// Individual event pages hold their own detailed content.

export const PROJECTS = [
  {
    slug: "through-the-looking-glass",
    number: "02",
    path: "/projects/through-the-looking-glass",
    partner: "NYG × Socialista",
    titleLine1: "Through the",
    titleLine2: "Looking Glass",
    artists: "Rebecca Grant de Longueuil",
    collection: "Yellow Brick Road",
    date: "14 October 2026",
    time: "8:00 PM",
    venue: "Socialista London",
    venueNote: "",
    access: "RSVP only",
    image: "/exhibition/looking-glass-poster.jpg",
    status: "upcoming",
  },
  {
    slug: "shape-of-elsewhere",
    number: "01",
    path: "/projects/shape-of-elsewhere",
    partner: "NYG × Tramp",
    titleLine1: "Shape of",
    titleLine2: "Elsewhere",
    artists: "Guilherme Albagli & Ulviyya Akhundova",
    collection: "",
    date: "23 June 2026",
    time: "6:00 – 8:00 PM GMT",
    venue: "Tramp, London",
    venueNote: "40 Jermyn Street, SW1Y 6DN",
    access: "By invitation",
    image: "/exhibition/invitation-1.jpg",
    status: "previous",
  },
];

export const UPCOMING_PROJECTS = PROJECTS.filter((p) => p.status === "upcoming");
export const PREVIOUS_PROJECTS = PROJECTS.filter((p) => p.status === "previous");
